import React from "react";
import { useCart } from "../context/CartContext";
import "./Cart.css";
import { FaTrash } from "react-icons/fa";
import { useLocation, useNavigate } from 'react-router-dom';

function Cart() {
    const { cartItems, removeItemFromCart, updateItemQuantity, clearCart } = useCart();
    const navigate = useNavigate();
    const location = useLocation();
    const customization = location.state?.customization;

    // Función para asegurar que el precio sea un número válido
    const parsePrice = (price) => {
        // Asegúrate de que el precio sea una cadena antes de llamar a replace
        const priceString = typeof price === 'string' ? price : String(price);

        // Elimina cualquier texto no numérico (como " c/u")
        const priceWithoutText = priceString.replace(/[^\d.-]/g, '');  // Esto elimina cualquier cosa que no sea números, puntos o guiones
        const parsedPrice = parseFloat(priceWithoutText);

        if (isNaN(parsedPrice)) {
            console.error(`El precio ${price} no es válido.`);
            return 0;  // Si el precio no es válido, retornar 0
        }

        return parsedPrice;
    };


    const formatPrice = (price) => {
        return new Intl.NumberFormat('es-AR', {
            style: 'currency',
            currency: 'ARS',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(price);
    };

    // Calcula el total del carrito
    const calculateTotal = () => {
        return cartItems.reduce((total, item) => {
            const priceToUse = item.promotions ? parsePrice(item['offer-price'] || item.price) : parsePrice(item.price);
            return total + priceToUse * item.quantity;
        }, 0);
    };

    return (
        <div className="cart">
            <h2>Carrito de Compras</h2>
            {cartItems.length === 0 ? (
                <div className="empty-cart-container">
                    <p className="empty-cart">Su carrito está vacío.</p>
                    <p className="empty-cart-description">Explora todos los productos disponibles y encuentra lo que necesitas en nuestra tienda. ¡Haz tu compra ahora!</p>
                    <div className="empty-cart-button">
                        <button onClick={() => navigate("/")}>Volver a la tienda</button>
                    </div>
                </div>
            ) : (
                <>
                    <h3>Productos:</h3>
                    {cartItems.map((item) => (
                        <div key={item.id} className="cart-item">
                            {item.promotions && <span className="promotion-label">En promoción</span>}
                            <div className="item-image">
                                <img src={require(`../assets/products/${item.img}`)} alt={item.name} />
                            </div>
                            <div className="item-details">
                                <p>{item.name}</p>
                                {item.promotions && <span className="promotion-label">¡En promoción!</span>}
                                <div className="customization-details">
                                    {item.customization?.colors?.length === 0 ? (
                                        <p><strong>Color:</strong> {item.customization.noApplyClicked ? 'No aplica' : 'No aplica'}</p>
                                    ) : item.customization?.colors?.length > 0 ? (
                                        <p><strong>Color:</strong> {item.customization.colors.map(color => color.name).join(", ")}</p>
                                    ) : (
                                        <p><strong>Color:</strong> No disponible</p>
                                    )}

                                    <p><strong>Tamaño:</strong> {item.customization?.size || 'No especificado'}</p>
                                    <p><strong>Nombre/Logo:</strong> {item.customization?.name || 'No especificado'}</p>
                                    <p><strong>Comentarios:</strong> {item.customization?.comments || 'Sin comentarios'}</p>
                                </div>
                                <p>
                                    {/* Mostrar precio promocional o normal */}
                                    {item.promotions ? (
                                        <>
                                            <span className="promotional-price">{formatPrice(parsePrice(item['offer-price'] || item.price) * item.quantity)}</span>
                                            <br />
                                            <span className="previous-price">Antes: {formatPrice(parsePrice(item.price))} c/u</span>
                                        </>
                                    ) : (
                                        <span>{formatPrice(parsePrice(item.price) * item.quantity)}</span>
                                    )}
                                </p>
                                <div className="quantity-controls">
                                    <button
                                        onClick={() => updateItemQuantity(item.id, item.quantity - 1)}
                                        disabled={item.quantity <= 1}
                                    >
                                        -
                                    </button>
                                    <span>{item.quantity}</span>
                                    <button
                                        onClick={() => updateItemQuantity(item.id, item.quantity + 1)}
                                    >
                                        +
                                    </button>
                                </div>
                                <button className="remove-button" onClick={() => removeItemFromCart(item.id)}>
                                    <FaTrash />
                                </button>
                            </div>
                        </div>
                    ))}
                    {/* Resumen del carrito */}
                    <div className="cart-summary-container">
                        <h3>Resumen de Compra:</h3>
                        <div className="cart-summary">
                            <div className="total">
                                <p className="total-label">Total: </p> {/* Total con 2 decimales */}
                                <p>{formatPrice(calculateTotal())}</p>
                            </div>
                            <div className="buttons-cart-summary">
                                <button onClick={clearCart}>Vaciar carrito</button>
                                <button onClick={() => navigate('/products')}>Seguir Comprando</button>
                                <button onClick={() => navigate('/checkout')}>Finalizar Compra</button> {/* Redirige a Checkout */}
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
}

export default Cart;
